import {
  isStrictDimention
} from '../../core/type-dimensions';

import {
  CONDITIONS_META
} from '../../common/config';

import {
  Dimension
} from '../../common/dimension.js';

import {
  RegExpConstructorModalController
} from '../editor/regexp-constructor/regexp-constructor-modal.component.js';

require('./query-builder-node.component.scss');

export class QueryBuilderNodeController {

  constructor(
    $scope,
    $timeout,
    $modal,
    CurrentModelService,
    ErrorHandlerService,
    FilterResource,
  ) {
    this.$scope = $scope;
    this.isDark = $scope.$root.theme == 'dark';
    this.$modal = $modal;
    this.$timeout = $timeout;
    // this.ErrorHandlerService = ErrorHandlerService;
    this.errorMessage = ErrorHandlerService.filterErrorMessage;
    this.CurrentModelService = CurrentModelService;
    this.FilterResource = FilterResource;

    this.operators = ['AND', 'OR'];
    this.operatorLabels = {
      'AND': gettext('И'),
      'OR': gettext('ИЛИ'),
    };
    this.conditionsMeta = CONDITIONS_META;
    this.dimension = this.CurrentModelService.model.dimensions[0];
    this.node = null;
    this.nodeValue = '';
  }

  $postLink() {
    this.dimensions = this.CurrentModelService.model.dimensions;

    const dim1 = {
      label: gettext('Текст'),
      is_flat: true,
      name: 'text_data',
      hierarchies: [{
        label: 'Default',
        levels: ['text_data'],
        name: 'default',
        rule_groups: [],
      }]
    };
    Object.setPrototypeOf(dim1, Dimension.prototype);
    const dim2 = {
      label: gettext('Локальное время'),
      is_flat: true,
      name: 'local_time',
      hierarchies: [{
        label: 'Default',
        levels: ['local_time'],
        name: 'default',
        rule_groups: [],
      }],
      measures: [{
        label: gettext('Дней назад'),
        name: 'day',
      }, {
        label: gettext('Часов назад'),
        name: 'hour',
        rule_groups: [],
      }, {
        label: gettext('Минут назад'),
        name: 'minute',
      }, ]
    };
    Object.setPrototypeOf(dim2, Dimension.prototype);
    this.dimensions = [...this.dimensions, dim1, dim2];


    if (this.isCondition) {
      this.dimension = this.dimensions.find(dimension =>
        dimension.name.startsWith(this.node.dimension));
      if (!this.dimension) {
        this.errorMessage.text = gettext('Неправильный параметр') + ` "dimension" : "${this.node.dimension}" `;
        this.errorMessage.source = 'query-builder';
      }
      this.updateConditions();
      this.$scope.$watch('$ctrl.node.condition', (newValue, oldValue) => {
        if (!newValue) return;
        try {
          const newType = this.conditionsMeta[newValue].controlType;
          const oldType = oldValue ? this.conditionsMeta[oldValue].controlType : null;
          if (newType !== oldType) {
            this.resetNodeValue();
          }
          this.nodeValue = this.node.value;
          if (this.isRegExp && this.nodeValue) {
            this.FilterResource.checkRegExp(this.nodeValue).then(errMessage => {
              this.node.value = this.nodeValue;
              if (errMessage) {
                this.errorMessage.text = errMessage;
                this.errorMessage.error = true;
                this.$scope.$apply();
              }
            });
          }
        } catch (err) { //
        }

      });
    }
  }

  get controlType() {
    if (this.node.dimension == 'text_data' && this.node.condition == '='){
      return 'text';
    }
    return this.conditionsMeta[this.node.condition].controlType;
  }

  get isQueryError() {
    return !!(this.errorMessage && this.errorMessage.text);
  }

  get isCondition() {
    return this.node && !this.node.hasOwnProperty('group');
  }

  get isGroup() {
    return !this.isCondition;
  }

  addCondition() {
    // if (this.isQueryError) return;
    const dimension = this.dimensions[0];
    this.node.group.rules.push({
      condition: '=',
      dimension: dimension.name,
      hierarchy: dimension.getDefaultHierarchy().name,
      value: '',
    });
  }

  regExpConstructor() {
    const regExpModalInstance = this.$modal.open({
        template: require('../editor/regexp-constructor/regexp-constructor-modal.component.html'),
        controller: RegExpConstructorModalController,
        windowClass: 'regexp-constructor',
        resolve: {
          regExp: () => this.nodeValue,
          colorNum: () => 0,
          comment: () => this.node.comment,
          showComment: () => true,
        },
      })
      .result.then(({
        regExp,
        comment
      }) => {
        if (regExp) this.nodeValue = regExp;
        if (comment) this.node.comment = comment;
        else delete this.node.comment;
        this.setValue();
      })
      .catch((error) => {
        console.error(error);
      });
  }

  get isRegExp() {
    return this.node.condition === 'R';
  }

  get valueSyle() {
    let width = this.dimension.hierarchies.length > 1 ? 600 : 390;
    if (this.dimension.measures) width += 150;
    return {
      width: `calc(100% - ${width}px)`,
      paddingRight: this.isRegExp ? '24px' : 'unset',
      marginRight: this.isRegExp ? '24px' : 'unset',
    };
  }

  addGroup() {
    // if (this.isQueryError) return;
    this.node.group.rules.push(this.createGroup());
  }

  createGroup() {
    return {
      group: {
        operator: this.operators[0],
        rules: [],
      },
    };
  }

  get isBlokTabs() {
    return this.errorMessage && this.errorMessage.error && this.errorMessage.source != 'policy-limit';
  }

  setValue() {
    if (this.isRegExp) {
      this.FilterResource.checkRegExp(this.nodeValue).then(errMessage => {
        if (errMessage) {
          this.errorMessage.text = errMessage;
          this.errorMessage.error = true;
          this.errorMessage.source = 'query-regexp';
        } else {
          this.errorMessage.error = false;
          this.node.value = this.nodeValue;
          this.node.label = this.node.value;
        }
      });
    } else {
      this.node.value = this.nodeValue;
      this.node.label = this.node.value;
    }
  }

  remove() {
    if ('node' in this.$scope.$parent.$ctrl) {
      this.$scope.$parent.$ctrl.node.group.rules =
        this.$scope.$parent.$ctrl.node.group.rules.filter(r => r !== this.node);
    }
  }

  onDimensionChange() {
    this.node.dimension = this.dimension.name;
    this.node.hierarchy = this.dimension.getDefaultHierarchy().name;
    this.resetNodeValue();
    this.updateConditions();
  }

  resetNodeValue() {
    if (this.node.condition === '^' || this.node.condition === '!^' || this.isRegExp) {
      this.node.value = this.nodeValue;
      this.node.label = this.nodeValue;
    } else {
      this.node.value = '';
      this.node.label = '';
    }

    if (this.dimension.measures) {
      this.nodeValue = 0;
      this.node.measure = this.dimension.measures[0].name;
      this.node.value = 0;
      this.node.label = 0;
    }
  }

  onHierarchyChange() {
    this.resetNodeValue();
    this.updateConditions();
  }

  isSearchable() {
    return !(isStrictDimention(this.node.dimension, this.node.hierarchy) || this.isBoolean());
  }

  isBoolean() {
    if (this.node.dimension === 'agent_attachedfile' && this.node.hierarchy === 'extracted') return true;
    if (this.node.dimension === 'agent_appinstallation' && this.node.hierarchy === 'is_update') return true;
    return false;
  }

  updateConditions() {
    if (this.isSearchable()) {
      this.conditions = [
        CONDITIONS_META['='], CONDITIONS_META['!'],
        CONDITIONS_META['^'], CONDITIONS_META['!^'],
        CONDITIONS_META['R'],
        CONDITIONS_META['D'], CONDITIONS_META['!D'],
      ];
    } else {
      this.conditions = [
        CONDITIONS_META['='], CONDITIONS_META['!'],
      ];
    }
    if (this.dimension.name === 'local_time') {
      this.conditions = [
        CONDITIONS_META['<'], CONDITIONS_META['>'],
      ];
    }

    if (!this.node.condition) {
      this.errorMessage.text = gettext('"condition" обязателен');
      this.errorMessage.error = true;
      return;
    }
    if (this.conditions.indexOf(CONDITIONS_META[this.node.condition]) === -1) {
      this.node.condition = this.conditions[0].name;
    }

  }

  onSelectValue(filter) {
    if (this.node.value) {
      this.node.value.push(filter);
    } else {
      this.node.value = [filter];
    }

  }
}

export const QueryBuilderNodeComponent = {
  bindings: {
    node: '<',
    isRoot: '<?',
  },
  template: require('./query-builder-node.component.html'),
  controller: QueryBuilderNodeController,
};



// WEBPACK FOOTER //
// ./src/filter/query-builder/query-builder-node.component.js